import { useNavigate, useParams } from "react-router-dom";
import { toast } from "@lumanity/ui/primitives";
import PageLayout from "@/components/PageLayout";
import PageHeader from "@/components/PageHeader";
import ProjectSetupForm from "@/components/ProjectSetupForm";

/** Create (no :id) or edit a project's setup through the project service. */
const ProjectSetupPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  return (
    <PageLayout mainClassName="container-md">
      <PageHeader title={id ? "Edit Project" : "New Project"} />
      <ProjectSetupForm
        projectId={id}
        onSaved={(project, warning) => {
          if (warning) toast({ title: "Project saved", description: warning, variant: "destructive" });
          navigate(`/projects/${project.id}`);
        }}
        onCancel={() => navigate(id ? `/projects/${id}` : "/")}
      />
    </PageLayout>
  );
};

export default ProjectSetupPage;
